import styles from './Divider.module.scss';
import React, {useEffect} from 'react';

function Divider(props) {

    useEffect(()=>{
    }, [])

    const typeHandler = () => {
        switch (props.type){
            case "text":
                return <div className={styles.h_divider}>
                    <div className={styles.shadow}></div>
                    <div className={styles.text}><i>{props.text}</i></div>
                </div>

            case "image":
                return <div className={styles.h_divider}>
                    <div className={styles.shadow}></div>
                    <div className={styles.text2}><img src={props.imgUrl} alt=""/></div>
                </div>

            case "line":
                return <div className={styles.h_divider}>
                    <div className={styles.shadow}></div>
                </div>
            default:
                console.error("what kind of type has been sent to Divider!!")
        }
    }

    return typeHandler();
}

export default Divider;

// source: https://www.csscodelab.com/css-divider-line-horizontal-code-snippet/
// https://codepen.io/fenixmedia/pen/myZbXd